// Classic › chrome: the header, footer and route-state copy (#1119). Nav
// links, Loading... and the not-found and error lines come from site-core.

const en = {
  /** The skip link (#822), visible only when focused. */
  skipToContent: 'Skip to content',
  /** The desktop overflow menu (#417). */
  more: 'More',
  toggleMenu: 'Toggle menu',
  poweredBy: 'Powered by ScoreLM',
  admin: 'Admin',
  backHome: 'Back to home',
}

export default en
